module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("his archival photograph volume in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Images of War")]), _vm._v(" series is dedicated to the armed forces service members who fought, were wounded and perished during the combat in Papua New Guinea during the early battles in the Southwest Pacific against Imperial Japan. We ponder upon viewing these photographs about the heroic sacrifice made to maintain freedom over tyranny, lest we forget. The author is indebted to the able assistance of the archivists at both the United States Army Military History Institute (USAMHI) at the United States Army War College in Carlisle, Pennsylvania and the Still Photo Section of the National Archives and Records Administration (NARA) in College Park, Maryland. Their diligence is much appreciated as they maintain and safeguard these superb historic images for the present tome as well as for future viewers.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c65c246","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Acknowledgements.vue
// module id = 66
// module chunks = 0